/**
 * Where Auth0 sends the user back after login. Development derives the origin
 * so any port works; that origin must be registered in the Auth0 tenant.
 */
export function authRedirectUri(env = process.env.NEXT_PUBLIC_ENV) {
  switch (env) {
    case "production":
      return "https://www.quarkle.ai/";
    case "staging":
      return "https://staging.quarkle.ai/";
    default:
      // no window during SSR; only ever used in the browser
      return typeof window === "undefined"
        ? "http://localhost:3000/"
        : `${window.location.origin}/`;
  }
}
